import { PagedResult } from '../../../shared/model/paged-result.model';
import { CreditCardTransactionDetail } from './credit-card-transaction-detail.model';

export class CreditCardTransactionSearchResult extends PagedResult {
  public constructor() {
    super();
    this.Result = new Array<CreditCardTransactionDetail>();
  }

  public Result: Array<CreditCardTransactionDetail>;
}
